/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2023-05-22 22:09:49
 */
import Cookies from 'js-cookie';

const TokenKey = 'token';

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey, token,{expires: 90});
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}
